import { useEffect, useState } from "react";

/** A countdown to a moment (ms since 1970), re-rendering every second while it runs */
export function useCooldown(initialUntil = 0) {
  const [until, setUntil] = useState(initialUntil);
  const [now, setNow] = useState(Date.now());
  const active = until > now;

  useEffect(() => {
    if (!active) return;
    const timer = window.setInterval(() => setNow(Date.now()), 1000);
    return () => window.clearInterval(timer);
  }, [active]);

  const seconds = Math.max(0, Math.ceil((until - now) / 1000));
  return {
    active,
    seconds,
    /** "4:05" */
    label: `${Math.floor(seconds / 60)}:${String(seconds % 60).padStart(2, "0")}`,
    start: (moment: number) => {
      setUntil(moment);
      setNow(Date.now());
    },
  };
}
